import { MailboxMessage, MailboxThread, SendMailboxEmailInput as SendEmailInput, SendMailboxEmailResult } from '@numeo/types-main-mobile'
import { mainServiceRootAxios } from '../setup/SetupAxios'

export type { MailboxMessage, MailboxThread, SendMailboxEmailInput as SendEmailInput } from '@numeo/types-main-mobile'

// New-convention routes (mailbox.router.ts) are mounted at the API root, not
// under /v1 like the rest of main-service — mainServiceRootAxios is the
// dedicated instance for that (see setup/SetupAxios.ts § EXCEPTIONS).
const BASE = '/email/mailbox'

export const mailboxApi = {
    async getAddress(): Promise<{ address: string }> {
        const { data } = await mainServiceRootAxios.get<{ success: boolean; data: { address: string } }>(`${BASE}/address/v1`)
        return data.data
    },

    async listThreads(params?: { cursor?: string; unreadOnly?: boolean }): Promise<{ threads: MailboxThread[]; nextCursor?: string; address: string }> {
        const { data } = await mainServiceRootAxios.get<{ success: boolean; data: { threads: MailboxThread[]; nextCursor?: string; address: string } }>(
            `${BASE}/threads/v1`,
            {
                params: { cursor: params?.cursor, unread_only: params?.unreadOnly },
            }
        )
        return data.data
    },

    async getThread(threadId: string): Promise<{ thread: MailboxThread; messages: MailboxMessage[] }> {
        const { data } = await mainServiceRootAxios.get<{ success: boolean; data: { thread: MailboxThread; messages: MailboxMessage[] } }>(
            `${BASE}/threads/${threadId}/v1`
        )
        return data.data
    },

    async send(input: SendEmailInput): Promise<SendMailboxEmailResult> {
        const { data } = await mainServiceRootAxios.post<{ success: boolean; data: SendMailboxEmailResult }>(`${BASE}/send/v1`, {
            to: input.to,
            cc: input.cc,
            subject: input.subject,
            bodyText: input.bodyText,
            bodyHtml: input.bodyHtml,
            inReplyToThreadId: input.inReplyToThreadId,
            idempotencyKey: input.idempotencyKey,
        })
        return data.data
    },

    async markThreadRead(threadId: string): Promise<void> {
        await mainServiceRootAxios.post(`${BASE}/threads/${threadId}/read/v1`)
    },
}
